import apiClient from './apiClient';

export interface F11H {
  f11h_01: string; f11h_11: string;
  f11h_91: string; f11h_92: string | null; f11h_93: string;
}
export interface ListResponse { data: F11H[]; total: number; page: number; size: number; }
export interface ValidationError { field: string; message: string; }

export const qualityReqApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/quality-req', { params })).data;
  },
  async get(code: string): Promise<F11H> {
    return (await apiClient.get(`/api/quality-req/${encodeURIComponent(code)}`)).data;
  },
  async create(data: { f11h_01: string; f11h_11: string }): Promise<F11H> {
    return (await apiClient.post('/api/quality-req', data)).data;
  },
  async update(code: string, data: { f11h_11: string }): Promise<F11H> {
    return (await apiClient.put(`/api/quality-req/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/quality-req/${encodeURIComponent(code)}`);
  },
};
